import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {SuccessDialogComponent} from '../components/success-dialog/success-dialog.component';

import {StorageService} from '../services/storage.service';
import {Messages} from '../shared/messages';
import {environment} from '../../environments/environment';
import {LoaderService} from '../services/loader.service';

@Injectable({
  providedIn: 'root',
})
export class AutoguardGuard {
  constructor(
    private storageSvc: StorageService,
    private location: Location,
    public dialog: MatDialog,
    private loaderSvc: LoaderService,
    public router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const sys_token = this.storageSvc.getValue('token');
    const cli_token = this.storageSvc.getValue('cli_token');
    const startWithSYS = this.location.path().startsWith('/sys/');
    const startWithCLI = this.location.path().startsWith('/cli/');
    const wrongURL = this.location.path() && !startWithSYS && !startWithCLI;

    if (sys_token || cli_token) {
      // URLPathが全然違う場合、
      if (wrongURL) {
        // SYSTokenがある場合、SYSホームページへ。それ以外、CLIホームページへ
        this.router.navigate([sys_token ? 'sys/home' : 'cli/home']);
        return false;
      }
      // SYSTokenがなし、CLITokenがあり、かつ、URLPathがSYSで開始する場合、
      if (!sys_token && startWithSYS) {
        this.router.navigate([environment.rootRedirectPath]);
        return false;
      }
      // SYSTokenがあり、CLITokenがなし、かつ、URLPathがCLIで開始する場合、
      if (!cli_token && startWithCLI) {
        this.successDialog(
          Messages.errorTitle,
          'この機能を使用するためには、顧客データ領域へのログインが必要です。',
        );
        return false;
      }
      return true;
    } else {
      // close for loading of the cli/case/list route in the main header when token error
      this.loaderSvc.dismiss();
      this.router.navigate([environment.rootRedirectPath]);
      return false;
    }
  }

  private successDialog(title, text): void {
    const successDialogRef = this.dialog.open(SuccessDialogComponent, {
      width: '500px',
      panelClass: 'sucess-overlay-pane',
      data: {title: title, name: text},
    });
    successDialogRef.afterClosed().subscribe((result) => {
      this.router.navigate(['sys/home']);
    });
  }
}
